import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Directive,
    ElementRef,
    ViewChild,
    inject,
    input,

    OnInit,
    signal,
    DestroyRef,
} from "@angular/core";


import { NavigationStart, Router, RouterModule } from "@angular/router";
import { ContactUsDialogService } from "../../contact-us-dialog.service";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LanguageSelectorComponent } from "../../language-selector.component";

// menu directive
@Directive({
    selector: "[menu]",
    standalone: true,
})
export class MenuDirective implements AfterViewInit {
    host = inject(ElementRef);
    timeout: any | undefined = undefined;
    debounce = input(200);

    ngAfterViewInit(): void {
        const trigger = this.host.nativeElement.querySelector("[trigger]");
        if (!trigger) return;

        let menu = null;
        const containerId = trigger.getAttribute("trigger");
        if (containerId) menu = this.host.nativeElement.querySelector(`#${containerId}`);
        if (!menu) menu = trigger.nextElementSibling;

        if (!menu) return;

        trigger.addEventListener("mouseenter", () => {
            clearTimeout(this.timeout);
            menu.classList.remove("hidden");
        });

        menu.addEventListener("mouseleave", () => {
            this.timeout = setTimeout(() => {
                menu.classList.add("hidden");
            }, this.debounce());
        });

        trigger.addEventListener("mouseleave", () => {
            this.timeout = setTimeout(() => {
                menu.classList.add("hidden");
            }, this.debounce());
        });

        menu.addEventListener("mouseenter", () => {
            clearTimeout(this.timeout);
        });
    }
}

@Component({
    selector: "in2-navbar",
    imports: [CommonModule,NgOptimizedImage, RouterModule, MenuDirective, LanguageSelectorComponent],
    templateUrl: "./navbar.component.html",
    styleUrls: ["./navbar.component.scss"],
    host: {
        "[class]": "navbarClass()",
    },
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit {
    @ViewChild("menuDialog") menuDialog!: ElementRef;
    
    readonly contactUsDialog = inject(ContactUsDialogService);
    private readonly router = inject(Router);
    private readonly destroyRef = inject(DestroyRef);

    isDialogOpen = signal(false);
    navbarClass = input("app-nav bg", {
        transform: (value: string) => {
            return value?.length ? value : "app-nav bg";
        },
    });
    ngOnInit() {
        this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => {
            if (e instanceof NavigationStart) this.closeMenuDialog();
        });
    }
    toggleMenuDialog() {
        if (this.isDialogOpen() === true) this.closeMenuDialog();
        else this.openMenuDialog();
    }

    openMenuDialog() {
        if(this.isDialogOpen() === true) return;
        const dialogEl = this.menuDialog.nativeElement;

        dialogEl.showModal();
        this.isDialogOpen.set(true);
        document.body.style.overflow = "hidden";
        dialogEl.addEventListener("click", (e: any) => {
            if (dialogEl === e.target) this.closeMenuDialog(e);
        });
    }

    closeMenuDialog(e?: any) {
        if (this.isDialogOpen() === false) return;
        e?.preventDefault();
        const dialogEl = this.menuDialog.nativeElement;
        dialogEl.setAttribute("closing", "");
        document.body.style.overflow = "auto";
        setTimeout(() => {
            dialogEl.removeAttribute("closing");
            dialogEl.close();
            this.isDialogOpen.set(false);
        }, 300);
    }
}
